export const arr1 = [
  { text: 'Задание: найди карту точек (звездочек), похожую на твою. И, если всё получится, ты узнаешь название и автора этой мелодии.', buttonTitle: 'Начать' },
]

export const arr2 = [
  { text: 'Поздравляю, ты нашел её!' },
  { text: 'Это Billie Eilish – Bad guy.', buttonTitle: 'Продолжить' },
]

export const hint = [
  { text: 'Смотри внимательнее.' },
]

export const task = [
  { text: 'Задание: найди карту точек (звездочек), похожую на твою. И, если всё получится, ты узнаешь название и автора этой мелодии.' },
]
